import * as services from 'services/webhooks';

export const SET_ERROR = 'webhooks/SET_ERROR';
export const CLEAR_ERROR = 'webhooks/CLEAR_ERROR';
export const REQUEST_STARTED = 'webhooks/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'webhooks/REQUEST_SUCCESSFUL';
export const GET_WEBHOOKS_FROM_SERVER = 'webhooks/GET_WEBHOOKS_FROM_SERVER';
export const SET_WEBHOOKS = 'webhooks/SET_WEBHOOKS';
export const DELETE_WEBHOOK = 'webhooks/DELETE_WEBHOOK';
export const CREATE_WEBHOOK = 'webhooks/CREATE_WEBHOOK';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setWebhooks = webhooks => ({
  type: SET_WEBHOOKS,
  webhooks,
});

export const getAllWebhooksFromServer = () => dispatch => {
  dispatch(requestStarted);
  services
    .getAllWebhooks()
    .then(webhooks => {
      dispatch(setWebhooks(webhooks));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching webhooks'));
      dispatch(requestCompleted());
    });
};

export const getWebhooksFromServer = webhookId => dispatch => {
  dispatch(requestStarted);
  services
    .getWebhooksForTemplate(webhookId)
    .then(webhooks => {
      dispatch(setWebhooks(webhooks));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching webhooks'));
      dispatch(requestCompleted());
    });
};

export const createWebhook = webhook => dispatch => {
  dispatch(requestStarted);
  services
    .createWebhook(webhook)
    .then(({ success }) => {
      if (success) {
        dispatch(getAllWebhooksFromServer());
      } else {
        dispatch(setError('Error adding webhook'));
      }
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteWebhook = webhookId => dispatch => {
  dispatch(requestStarted);
  services
    .deleteWebhook(webhookId)
    .then(({ success }) => {
      if (success) {
        dispatch(getAllWebhooksFromServer());
      } else dispatch(setError('Error deleting webhook'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
